<template>
	<div class="sidebar">
		<div class="sidebar-left">
			<div class="tuomain">
				<img src="@/assets/img/topbu.png" alt="">
			</div>
			<div class="leftmains">
				<ul class="ullist">
					<li v-for="(item,index) in leftlist" :key="index" :class="item.light==1?'baise':''" @click="xuan(index,item)">
						<img v-if="item.light==1" :src="url+item.sele_icon" alt="">
						<img v-else :src="url+item.icon" alt="">
						<span>{{item.title}}</span>
					</li>
				</ul>
			</div>
		</div>
		<div :class="isdian==1?'sidebar-right':'sidebar-rightt'" >
			<div class="main-top">
				<span>{{title}}</span>
			</div>
			<div>
				<ul class="bigul">
					<li v-for="(item,index) in leftlist[xuanzhong].children" :key="index" class="samallli">
						<div class="spanbig" @click="xuanzhe(index,item,leftlist[xuanzhong])">
							<span :class="item.light==1?'lanse':''">{{item.title}}</span>
							<img v-if='item.children' :class="{'arrowTransform':!item.show, 'arrowTransformReturn':item.show}" src="@/assets/img/xia.png"
							 alt="">
						</div>
						<div v-if="item.show==1&&item.children">
							<ul class="xiaouls">
								<li v-for="(items,indexs) in item.children" :key="indexs" class="xiaoliss" @click="xuanzhe1(indexs,items,index)">
									<span :class="items.light==1?'lanse':''">{{items.title}}</span>
								</li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
			<div class="endbutons" @click="dianzhongs">
                <img v-if="isdian==1" src="@/assets/img/zuoce.png" alt="">
			</div>
		</div>
		<div class="shugangs">
            <div class="xiaoshu" @click="dianzhongs">

			   <img v-if="isdian==0" src="@/assets/img/zuoces.png" alt="">
			</div>
		</div>
	</div>
</template>
<script>
    import Vue from 'vue'
	import Bus from '../../assets/js/bus.js'
	export default {
		data() {
			return {
				url: this.$store.state.p_url,
				imgUrl: this.$store.state.img_url,
				leftlist: [{
					children:[],
					icon: "/basic/erp_rule/x1.png",
					sele_icon: "/basic/erp_rule/x.png"
				}],
				xuanzhong: 0,
				title: '',
				breadArr:[],
				isdian:1,
			}
		},
		methods: {
			menuList() {
				let that = this
				that.$axios.post(that.url + "crm/auth/menuList").then(res => {
					if (Number(res.data.code) == 200) {
						let indexone = window.sessionStorage.getItem('indexone')
						let indextwo = window.sessionStorage.getItem('indextwo')
						let indexthree = window.sessionStorage.getItem('indexthree')
						if (indexone != undefined && indexone != '') {
							res.data.data.forEach((item, index) => {
								item.light = 0
								if (item.children) {
									item.children.forEach((items, indexs) => {
										items.light = 0
										if (items.children) {
											items.children.forEach((itemss, indexss) => {
												itemss.light = 0
											})
										}
									})
								}
							})
							res.data.data[indexone].light = 1
							if (indextwo != -1) {
							   if(res.data.data[indexone].children)	{
                                  res.data.data[indexone].children[indextwo].light = 1
							   }
							}
							if (indexthree != -1) {
								res.data.data[indexone].children[indextwo].children[indexthree].light = 1
								res.data.data[indexone].children[indextwo].show=true
							}
							that.leftlist = res.data.data
							that.title = window.sessionStorage.getItem('title')
							that.xuanzhong = window.sessionStorage.getItem('xuanzhong')
						} else {
							res.data.data.forEach((item, index) => {
								item.light = 0
								if (item.children) {
									item.children.forEach((items, indexs) => {
										items.light = 0
										items.show = true
										if (items.children) {
											items.children.forEach((itemss, indexss) => {
												itemss.light = 0
											})

										}
									})
								}
							})
							res.data.data[0].light = 1
							if (res.data.data[0].children) {
								res.data.data[0].children[0].light = 1
								if (res.data.data[0].children[0].children) {
									res.data.data[0].children[0].children[0].light = 1
								}
							}
							that.leftlist = res.data.data
							this.title = res.data.data[0].title

						}
					}
				})
			},
			xuan(index, item) {
				this.breadArr = [];
				this.xuanzhong = index
				this.title = item.title
				this.leftlist.forEach((item, index) => {
					item.light = 0
					if (item.children) {
						item.children.forEach((items, indexs) => {
							items.light = 0
							if (items.children) {
								items.children.forEach((itemss, indexss) => {
									itemss.light = 0
								})
							}
						})
					}
				})
				let path = ''
				if (item.children) {
					if (item.children[0].children) {
						this.$router.push({
							path: item.children[0].children[0].name
						})
						path = item.children[0].children[0].name
						window.sessionStorage.setItem('indextwo', 0)
						window.sessionStorage.setItem('indexthree', 0)
						let obj={
							"title": item.children[0].title,
					        "route": ''
						}
                        this.breadArr.push(obj)
						let obj1={
							"title": item.children[0].children[0].title,
					        "route": item.children[0].children[0].name
						}
					   this.breadArr.push(obj1)
						this.leftlist[index].children[0].show = true
				         window.sessionStorage.setItem('item',JSON.stringify(item.children[0].children[0]))
					} else {
						this.$router.push({
							path: item.children[0].name
						})
						let obj11={
							"title": item.children[0].title,
					        "route": item.children[0].name
						}
                        this.breadArr.push(obj11)
						path = item.children[0].name
						window.sessionStorage.setItem('indextwo', 0)
						window.sessionStorage.setItem('indexthree', -1)
						window.sessionStorage.setItem('item',JSON.stringify(item.children[0]))
					}
				}
				this.leftlist[index].light = 1
				if (this.leftlist[index].children) {
					this.leftlist[index].children[0].light = 1
					if (this.leftlist[index].children[0].children) {
						this.leftlist[index].children[0].children[0].light = 1
					}
				}

				window.sessionStorage.setItem('title', item.title)
				window.sessionStorage.setItem('xuanzhong', index)
				window.sessionStorage.setItem('path', path)
				window.sessionStorage.setItem('indexone', index)
				Bus.$emit('emitObj', this.breadArr);
				this.isdian=1
                this.$emit('getinfo',this.isdian)
				Bus.$emit('getinfo', this.isdian);
			},
			dianzhongs(){
			    if(this.isdian==0){
					this.isdian=1
				}else{
					this.isdian=0
				}
				this.$emit('getinfo',this.isdian)
				Bus.$emit('getinfo', this.isdian);

			},
			xuanzhe(index, item, bigitem) {
				this.breadArr = [];
				this.leftlist[this.xuanzhong].children.forEach((itemt, indext) => {
					itemt.light = 0
					if (itemt.children) {
						itemt.children.forEach((itemtt, indextt) => {
							itemtt.light = 0
						})
					}
				})
				let path = ''
				this.leftlist[this.xuanzhong].children[index].light = 1
				if (item.children) {
					if (this.leftlist[this.xuanzhong].children[index].show == true) {

						this.leftlist[this.xuanzhong].children[index].show = false
					} else {
						this.leftlist[this.xuanzhong].children[index].show = true
					}
				} else {
					this.$router.push({
						path: item.name
					})
					path = item.name
				}
				let obj11={
					"title": item.title,
					"route": item.name
				}
			    this.breadArr.push(obj11)
				window.sessionStorage.setItem('title', item.title)
				window.sessionStorage.setItem('xuanzhong', this.xuanzhong)
				window.sessionStorage.setItem('path', path)
				window.sessionStorage.setItem('indextwo', index)
				window.sessionStorage.setItem('indexone', this.xuanzhong)
				window.sessionStorage.setItem('indexthree', -1)
				Bus.$emit('emitObj', this.breadArr);
				window.sessionStorage.setItem('item',JSON.stringify(item))

			},
			xuanzhe1(indexs, items, index) {
				this.breadArr = [];
				this.leftlist[this.xuanzhong].children.forEach((itemt, indext) => {
					itemt.light = 0
					if (itemt.children) {
						itemt.children.forEach((itemtt, indextt) => {
							itemtt.light = 0
						})
					}
				})
				this.leftlist[this.xuanzhong].children[index].light = 1
				this.leftlist[this.xuanzhong].children[index].children.forEach((itemm, indexm) => {
					itemm.light = 0
				})
				this.leftlist[this.xuanzhong].children[index].children[indexs].light = 1
				this.$router.push({
					path: items.name
				});
				let obj1={
					"title": this.leftlist[this.xuanzhong].children[index].title,
					"route": this.leftlist[this.xuanzhong].children[index].name
				}
				this.breadArr.push(obj1)

				let obj11={
					"title": items.title,
					"route": items.name
				}
			    this.breadArr.push(obj11)

				window.sessionStorage.setItem('title', items.title)
				window.sessionStorage.setItem('xuanzhong', this.xuanzhong)
				window.sessionStorage.setItem('path', items.name)
				window.sessionStorage.setItem('indexthree', indexs)
				window.sessionStorage.setItem('indexone', this.xuanzhong)
				window.sessionStorage.setItem('indextwo', index)
				Bus.$emit('emitObj', this.breadArr);
				window.sessionStorage.setItem('item',JSON.stringify(items))

			},
		},
		mounted() {
			this.menuList()
		}
	}
</script>
<style scoped>
	.sidebar {
		position: fixed;
		left: 0;
		top: 0;
		/* width: 230px; */
		height: 100%;
		/* overflow-x: hidden;
		overflow-y: scroll; */
		z-index: 999;
		display: flex;
	}

	.sidebar-left {
		width: 90px;
		background-color: #303945;
		height: 100%;
	}

	.sidebar-right {
		width: 140px;
		background-color: #fff;
		height: 100%;
		position: relative;
	}
	.sidebar-rightt{
		width: 0px;
		background-color: #fff;
		height: 100%;
		position: relative;
		display: none;
	}
	.endbutons{
		width: 10px;
		height: 90px;
		position: absolute;
		bottom: 0px;
		right: 0px;
		cursor: pointer;
	}
	.endbutons img{
		width: 10px;
		height: 90px;
		display: block;
	}
	.tuomain {
		width: 90px;
		height: 80px;
	}

	.tuomain img {
		width: 90px;
		height: 70px;
		display: block;
	}

	.ullist li {
		width: 90px;
		height: 80px;
		font-size: 14px;
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.ullist li img {
		width: 35px;
		height: 35px;
		display: block;
		margin-bottom: 2px;
	}

	.baise {
		color: #fff;
		background-color: #1C2937 !important;
	}

	.main-top {
		width: 100%;
		height: 55px;
		border-bottom: 1px solid #e4e5e7;
		border-right: 1px solid #e4e5e7;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.spanbig {
		width: 120px;
		height: 50px;
		display: flex;
		font-size: 14px;
		color: #333333;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 600;
	}

	.xiaoliss {
		width: 130px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		cursor: pointer;
	}

	.lanse {
		color: #409EFF !important;
	}

	.arrowTransform {
		transition: 0.2s;
		transform-origin: center;
		transform: rotateZ(-180deg);
		margin-left: 2px;
	}

	.arrowTransformReturn {
		transition: 0.2s;
		transform-origin: center;
		transform: rotateZ(0deg);
		margin-left: 2px;
	}
	.shugangs{
		width: 10px;
		height: 100%;
		position: relative;
	}
	.xiaoshu{
		width: 100%;
		position: absolute;
		bottom: 0;
	}
	.xiaoshu img{
		width: 10px;
		height: 92px;
		display: block;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/comment/sidebars.vue